interface ImageProps {
    src: string;
    width: number;
    height: number;
}

export type PartnerIconType = 'default' | 'light';

export interface PartnerContextProps {
    path: string;
    website: string;
    theme: {
        sidebar: {
            variant: {
                admpanel: {
                    textColor: string;
                    titleFontSize: string;
                    separatorLineColor: string;
                    backgroundColor: string;
                    backgroundSubMenu: string;
                    backgroundActiveMenu: string;
                };
            };
        };
        button: {
            variant: {
                primary: {
                    colors: {
                        inherit: string;
                    };
                    colorsIcon: {
                        inherit: string;
                    };
                    text: {
                        color: string;
                    };
                };
            };
        };
        tab: {
            variant: {
                primary: {
                    colors: {
                        textColor: string;
                        textSelected: string;
                        borderSelected: string;
                    };
                };
            };
        };
        table: {
            variant: {
                default: {
                    header: {
                        backgroundColor: string;
                    };
                };
            };
        };
    };
    root: {
        title: {
            stroke: string;
            stroke_supply: string;
            textColor: string;
        };
        background: string;
        footer: {
            backgroundColor: string;
            separatorColor: string;
            image: ImageProps;
            gray_700: string;
            gray_800: string;
        };
        sidebar: {
            image: ImageProps;
            icons: PartnerIconType;
            mobile: {
                backgroundColor: string;
                accentColor: string;
                listBackgroundColor: string;
                listTextColor: string;
                activeBackgroundColor: string;
                activeTextColor: string;
            };
        };
        header: {
            badge: {
                image: {
                    backgroundColor: string;
                    textColor: string;
                };
                content: {
                    textColor: string;
                };
            };
        };
        condoindica: {
            name: string;
            menu: string;
            url: string;
            fontSize: string;
        };
    };
    company: {
        name: string;
        favicon: string;
        address: {
            line_one: string;
            line_two: string;
        };
        phones: {
            call_center: string;
            whatsapp_full: string;
            whatsapp_formatted: string;
        };
        information: {
            line_one: string;
            line_two: string;
        };
        gender: {
            the: string;
        };
    };
    pages: {
        login: {
            backgroundColor: string;
            logo: ImageProps;
        };
        indica: {
            header: {
                textColor: string;
            };
            steps: {
                textColor: string;
                arrowSrc: string;
            };
            terms: {
                textColor: string;
            };
            cta: {
                backgroundColor: string;
                titleColor: string;
                subTitleColor: string;
                textColor: string;
            };
        };
    };
}

export const partnerDefault: PartnerContextProps = {
    path: 'adm',
    website: 'https://condolivre.com.br/',
    theme: {
        sidebar: {
            variant: {
                admpanel: {
                    textColor: 'white',
                    titleFontSize: 'v_12',
                    separatorLineColor: 'blue_300',
                    backgroundColor: 'gray_800',
                    backgroundSubMenu: '#6086d0',
                    backgroundActiveMenu: 'blue_300'
                }
            }
        },
        button: {
            variant: {
                primary: {
                    colors: {
                        inherit: '#0052CC'
                    },
                    colorsIcon: {
                        inherit: '#0448AF'
                    },
                    text: {
                        color: '#ffffff'
                    }
                }
            }
        },
        tab: {
            variant: {
                primary: {
                    colors: {
                        textColor: '#6D7688',
                        textSelected: '#0C0F14',
                        borderSelected: '#0052CC'
                    }
                }
            }
        },
        table: {
            variant: {
                default: {
                    header: {
                        backgroundColor: '#474E5E'
                    }
                }
            }
        }
    },
    root: {
        title: {
            stroke: '#A9B4BF',
            stroke_supply: '#8468DE',
            textColor: '#0c0f14'
        },
        background: '#ECF0F4',
        footer: {
            backgroundColor: '#ffffff',
            separatorColor: '#f1efef',
            image: {
                src: '/images/Logo_condolivre_pos.png',
                width: 200,
                height: 52
            },
            gray_700: 'gray_700',
            gray_800: 'gray_800'
        },
        sidebar: {
            image: {
                src: '/images/logo_small.webp',
                width: 120,
                height: 31
            },
            icons: 'default',
            mobile: {
                backgroundColor: '#262c36',
                accentColor: '##474e5e',
                listBackgroundColor: '#ffffff',
                listTextColor: '#6d7688',
                activeBackgroundColor: '#6592e7',
                activeTextColor: '#ffffff'
            }
        },
        header: {
            badge: {
                image: {
                    backgroundColor: '#d4e2fe',
                    textColor: '#ffffff'
                },
                content: {
                    textColor: '#262c36'
                }
            }
        },
        condoindica: {
            name: 'CondoIndica',
            menu: 'CondoIndica',
            url: '/images/condoIndica.png',
            fontSize: '32px'
        }
    },
    company: {
        name: 'Condo Livre',
        favicon: '/favicon.ico',
        address: {
            line_one:
                'Avenida Presidente Juscelino Kubitschek nº 1830 Sala 51 - Bloco 01 - Condomínio Edifício São Luiz',
            line_two: 'Vila Nova Conceição, São Paulo SP - CEP: 04543-900'
        },
        phones: {
            call_center: '(011) 3097-9918',
            whatsapp_full: '5511918513094',
            whatsapp_formatted: '(011) 91851-3094'
        },
        information: {
            line_one:
                'A CondoLivre Análise de Crédito e Cobrança Ltda, inscrita sob o CNPJ 28.314.050/0001-62, é uma Fintech especializada em',
            line_two: 'soluções de crédito para o universo de condomínios.'
        },
        gender: {
            the: 'a'
        }
    },
    pages: {
        login: {
            backgroundColor: '#474E5E',
            logo: {
                src: '/images/logo_small.webp',
                width: 120,
                height: 31
            }
        },
        indica: {
            header: {
                textColor: '#0C0F14'
            },
            steps: {
                textColor: '#474E5E',
                arrowSrc: '/images/icon_md_arrow_right.svg'
            },
            terms: {
                textColor: '#6D7688'
            },
            cta: {
                backgroundColor: '#D4E2FE',
                titleColor: '#0C0F14',
                subTitleColor: '#474E5E',
                textColor: '#6D7688'
            }
        }
    }
};

export const partnerBank: PartnerContextProps = {
    path: 'partnerbankadm',
    website: 'https://www.partnerbank.com.br/',
    theme: {
        sidebar: {
            variant: {
                admpanel: {
                    textColor: 'white',
                    titleFontSize: 'v_12',
                    separatorLineColor: '#0075D5',
                    backgroundColor: '#0E1124',
                    backgroundSubMenu: '#0561b0',
                    backgroundActiveMenu: '#0275d5'
                }
            }
        },
        button: {
            variant: {
                primary: {
                    colors: {
                        inherit: '#01A8F7'
                    },
                    colorsIcon: {
                        inherit: '#0072cb'
                    },
                    text: {
                        color: '#ffffff'
                    }
                }
            }
        },
        tab: {
            variant: {
                primary: {
                    colors: {
                        textColor: '#ffffff',
                        textSelected: '#ffffff',
                        borderSelected: '#0052CC'
                    }
                }
            }
        },
        table: {
            variant: {
                default: {
                    header: {
                        backgroundColor:
                            'linear-gradient(150deg, rgba(0,117,213,1) 0%, rgba(14,17,36,1) 40%, rgba(14,17,36,1) 60%, rgba(102,45,145,1) 100%)'
                    }
                }
            }
        }
    },
    root: {
        title: {
            stroke: '#0075D5',
            stroke_supply: '#0075D5',
            textColor: '#ffffff'
        },
        background: '#010221',
        footer: {
            backgroundColor:
                'linear-gradient(150deg, rgba(0,117,213,1) 0%, rgba(14,17,36,1) 40%, rgba(14,17,36,1) 60%, rgba(102,45,145,1) 100%)',
            separatorColor: '#0075D5',
            image: {
                src: '/providers/partnerbank/footer.png',
                width: 144,
                height: 66
            },
            gray_700: 'white',
            gray_800: 'white'
        },
        sidebar: {
            image: {
                src: '/providers/partnerbank/logo.svg',
                width: 86,
                height: 32
            },
            icons: 'light',
            mobile: {
                backgroundColor: '#010221',
                accentColor: '#0E1124',
                listBackgroundColor: '#0E1124',
                listTextColor: '#ffffff',
                activeBackgroundColor: '#0275d5',
                activeTextColor: '#ffffff'
            }
        },
        header: {
            badge: {
                image: {
                    backgroundColor: '#ffffff',
                    textColor: '#262c36'
                },
                content: {
                    textColor: '#ffffff'
                }
            }
        },
        condoindica: {
            name: 'PartnerBankIndica',
            menu: 'PartnerBank Indica',
            url: '/providers/partnerbank/indica.svg',
            fontSize: '22px'
        }
    },
    company: {
        name: 'PartnerBank',
        favicon: '/providers/partnerbank/favicon.ico',
        address: {
            line_one: 'Rua Paes Leme, 215, 14º andar - Pinheiros, São Paulo - SP, 05424-150',
            line_two: ''
        },
        phones: {
            call_center: '(011) 3090-3227',
            whatsapp_full: '5511980841487',
            whatsapp_formatted: '(011) 98084-1487'
        },
        information: {
            line_one:
                'PartnerBank Instituição de Pagamentos S.A. | Condolivre Análise de Crédito e Cobrança Ltda.',
            line_two: 'CNPJ: 28.979.546/0002-36 | CNPJ: 29.314.050/0001-62'
        },
        gender: {
            the: 'o'
        }
    },
    pages: {
        login: {
            backgroundColor: '#010221',
            logo: {
                src: '/providers/partnerbank/logo.svg',
                width: 197,
                height: 73
            }
        },
        indica: {
            header: {
                textColor: '#ffffff'
            },
            steps: {
                textColor: '#ffffff',
                arrowSrc: '/providers/partnerbank/icon_md_arrow_right.svg'
            },
            terms: {
                textColor: '#ffffff'
            },
            cta: {
                backgroundColor:
                    'linear-gradient(101.78deg, #0075D5 0%, #0E1124 37.59%, #0E1124 57.09%, #662D91 95.15%)',
                titleColor: '#ffffff',
                subTitleColor: '#ffffff',
                textColor: '#ffffff'
            }
        }
    }
};

export const themes: { [key: string]: PartnerContextProps } = {
    [partnerDefault.path.toLowerCase()]: partnerDefault,
    [partnerBank.path.toLowerCase()]: partnerBank
};

export const extractTheme = (path: string | undefined | null) => {
    if (typeof path !== 'string' || !path.trim().length) {
        return partnerDefault;
    }
    return (
        themes[((path || '').trim().split('.')[0] || 'undefined').toString().toLowerCase()] ||
        partnerDefault
    );
};
